import React from "react";
import styled from "styled-components";
import Stars from "react-stars";

export default ({ n, value }) => (
  <RatingWrap>
    <Stars count={5} size={27} value={value} edit={false} color2={"#F76367"} />
    <Text>{n} Reviews</Text>
  </RatingWrap>
);

const RatingWrap = styled.div`
  margin-top: 0.75rem;
  display: flex;
  flex-direction: column;
  font-family: "CircularStd-Book", sans-serif;
  span {
    margin: 0 0.25rem;
  }
`;

const Text = styled.div`
  margin-left: auto;
  font-size: 1.25rem;
  color: #b1b1b1;
`;



// WEBPACK FOOTER //
// ./src/components/common/candidate/ScheduleCall/components/Rating/index.js